import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { getProgramNameFromUnitLong } from '@modules/advancement/purchaseOrder/utils';
import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import { programToProgramName } from '@modules/shared/constants';
import { selectedOrganizationSel } from '@shared/duck/selectors/general.selectors';

import { useGetUnitPendingLeadershipPositionsQuery } from './api';

export function useUnitPendingLeadershipPositions() {
  const org = useSelector(selectedOrganizationSel);
  const orgGuid = org?.organizationGuid;
  const isUnit = String(org?.organizationType).toLowerCase() === 'units';
  const res = useGetUnitPendingLeadershipPositionsQuery(
    { orgGuid },
    {
      skip:
        !isUnit ||
        !orgGuid ||
        !featureFlags.getFlag('SBL_4848_PENDING_LEADERSHIP_POSITIONS'),
    },
  );

  const positions = res.data;

  const youthPositions = useMemo(() => {
    if (!positions) return [];
    return positions.filter(item => !item.isAdultPosition);
  }, [positions]);

  const approvableItems = useMemo(
    () =>
      youthPositions.filter(
        item =>
          getProgramNameFromUnitLong(item.unitLong) ===
          programToProgramName[org.program],
      ),
    [youthPositions, org.program],
  );

  /** Only youth positions are considered */
  const pendingCount = youthPositions.length || 0;

  return {
    response: res,
    /** Only youth positions are considered for the count */
    pendingCount,
    /** Only approvable youth positions are considered for the count */
    approvableItemsCount: approvableItems.length || 0,
    /** All positions incl. adult ones */
    positions,
    /** Positions filtered by isAdultPosition */
    youthPositions,
  };
}
